(function () {
  const rootSelector = "[data-jfh-identity-carousel]";
  const boundAttribute = "data-jfh-identity-carousel-bound";

  function initCarousel(root) {
    if (!root || root.hasAttribute(boundAttribute)) return;

    const slides = Array.from(root.querySelectorAll("[data-jfh-identity-slide]"));
    if (slides.length <= 1) return;

    root.setAttribute(boundAttribute, "true");

    const prevButton = root.querySelector("[data-jfh-identity-prev]");
    const nextButton = root.querySelector("[data-jfh-identity-next]");
    const dots = Array.from(root.querySelectorAll("[data-jfh-identity-dot]"));
    const autoplay = root.dataset.autoplay === "true";
    const interval = Math.max(Number(root.dataset.interval) || 4000, 3000);
    let activeIndex = Math.max(slides.findIndex((slide) => slide.classList.contains("is-active")), 0);
    let timer = null;

    function showSlide(index) {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", isActive ? "false" : "true");
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });
    }

    root.jfhIdentityShowSlide = showSlide;

    function stopAutoplay() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function startAutoplay() {
      if (!autoplay || timer) return;
      timer = window.setInterval(() => showSlide(activeIndex + 1), interval);
    }

    prevButton?.addEventListener("click", () => {
      showSlide(activeIndex - 1);
      stopAutoplay();
      startAutoplay();
    });

    nextButton?.addEventListener("click", () => {
      showSlide(activeIndex + 1);
      stopAutoplay();
      startAutoplay();
    });

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        showSlide(Number(dot.dataset.index) || 0);
        stopAutoplay();
        startAutoplay();
      });
    });

    root.addEventListener("mouseenter", stopAutoplay);
    root.addEventListener("mouseleave", startAutoplay);
    root.addEventListener("focusin", stopAutoplay);
    root.addEventListener("focusout", startAutoplay);

    showSlide(activeIndex);
    startAutoplay();
  }

  function initAll(scope) {
    const root = scope?.matches?.(rootSelector) ? scope : null;
    const roots = root ? [root] : Array.from((scope || document).querySelectorAll(rootSelector));
    roots.forEach(initCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  document.addEventListener("shopify:block:select", (event) => {
    const slide = event.target?.closest?.("[data-jfh-identity-slide]");
    const root = slide?.closest?.(rootSelector);
    if (!slide || !root || typeof root.jfhIdentityShowSlide !== "function") return;

    const slides = Array.from(root.querySelectorAll("[data-jfh-identity-slide]"));
    const index = slides.indexOf(slide);
    if (index >= 0) root.jfhIdentityShowSlide(index);
  });
})();
